import { render } from "./NewDocumentOverlay.vue?vue&type=template&id=bc6c703c"
import script from "./NewDocumentOverlay.vue?vue&type=script&lang=js"
export * from "./NewDocumentOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__